import React, { useState, useEffect } from "react";
import { Grid,  Box, Typography} from "@mui/material";

import CircularProgress from "@mui/material/CircularProgress";
import SearchBox from "../shared/searchbox";
import PatientList from "./patient_list";
//import { useStyles } from "../../style";
import PeopleIcon from "@mui/icons-material/People";
import { useAuth } from "../../contexts/AuthContext";
import AccessLocalStorage from "../../services/localStorage";
import { getApiUrl } from "../../services/api_service";
import { dashboardText, lightcolor, paddingbox, pcolor, redHeading, right, whitecolor } from "../../style2";

function MyPupil() {
  //const classes = useStyles();
  const rowsPerPage = 1000;
  const [page, setPage] = React.useState(0);
  const [patients, setPatients] = useState([]);
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const ls = new AccessLocalStorage();
  const auth = useAuth();

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }
    //const token = authTokens.accessToken;
    const url = getApiUrl();
    fetch(url + process.env.REACT_APP_GET_PATIENTS, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          response.json().then(data => {
            setPatients(data);
            setFilteredPatients(data);
          })
        } else if (response.status == 401) {
          //setError("Unauthorized access");
          auth.logoutUser();
        }
        else {
          setError("Unable to process your request.");
        }
      })

      .catch((err) => {
        setError(err.message || "An error occurred.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleSearch = (searchValue) => {
    //setFilteredPatients(FilteredSearch(patients, searchValue));
    setFilteredPatients(patients.filter(t =>
      (String(`${t.user.firstName} ${t.user.surname}`).toLowerCase().indexOf(String(searchValue).toLowerCase()) > -1) ||
      //(t.user.surname && String(t.user.surname).toLowerCase().indexOf(String(searchValue).toLowerCase()) > -1) ||
      (t.user.nhsNumber && t.user.nhsNumber.indexOf(searchValue) > -1)));
  };

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage - 1);
  // };

  // function pageCount() {
  //   return Math.ceil(filteredPatients.length / rowsPerPage);
  // }

  //const [comingSoonDialogOpen, setComingSoonDialogOpen] = useState(false);
  // const handleComingSoonDialogOpen = () => {
  //   setComingSoonDialogOpen(true);
  // };

  // const handleComingSoonDialogClose = () => {
  //   setComingSoonDialogOpen(false);
  // };

  const renderPageHeading = (many) => {
    if (ls.isTeacher()) {
      if (many)
        return "My Pupils";
      else
        return "My Pupil";
    }
    else if (ls.isPediatrician() || ls.isAdmin()) {
      if (many)
        return "My Patients";
      else
        return "My Patient";
    }
  }


  return (
    <>
      <Box sx={paddingbox} >
        <Grid container>
          <Grid item xs={12}>
            <Typography component="h1" 
            sx={redHeading}>Welcome</Typography>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" alignItems={"center"}>
              <PeopleIcon />
              <Box sx={{ paddingRight: "10px" }} />
              <Typography sx={dashboardText}>
                {renderPageHeading(filteredPatients.filter(t => !t.isDeleted).length > 1)}
              </Typography>
              {filteredPatients.filter(t => !t.isDeleted).length > 1 ? <div style={{ backgroundColor: whitecolor, color: pcolor, fontSize: "15px", borderRadius: "30px", padding: "3px 10px", marginLeft: "20px" }}>{filteredPatients.filter(t => !t.isDeleted).length}</div> : null}
              <Box m={2} />
              <Grid item xs={2} sx={right}>
                <SearchBox onChange={(newValue) => handleSearch(newValue)} />
              </Grid>
            </Box>
          </Grid>
          <Box m={2} />
          <Grid container  sx={{ backgroundColor: lightcolor, border: `2px solid ${whitecolor}`, padding: "1.5rem", borderRadius: "10px" }}>
            {loading && (
              <Grid item align={"center"}>
                <CircularProgress color="success" />
              </Grid>
            )}
            {error ? (
              <Grid item align={"center"}>Error: {error}</Grid>
            ) : (
              <PatientList patients={filteredPatients} page={page} rowsPerPage={rowsPerPage}/>
            )}
          </Grid>
        </Grid>
      </Box>
      {/* <Box className={classes.paginationPadding}>
        <Grid container justifyContent="center" item xs={12} spacing={1}>
          <Pagination
            style={{
              backgroundColor: "white",
              padding: 7,
              paddingLeft: 50,
              paddingRight: 50,
              borderRadius: 9,
            }}
            className={classes.pagination}
            page={page + 1}
            count={pageCount()}
            onChange={handleChangePage}
          />
        </Grid>
      </Box> */}
    </>
  );
}

export default MyPupil;
